import React from 'react'

const Block = (props) => {
    return (
        <>
            <div className="col-md-4 mt-3">
    <div className="border rounded p-3 height">
    <h3 className='text-primary font-weight-bold'>{props.head}</h3>
    <p className="text-justify">{props.para}</p>

    </div>
</div>
        </>
    )
}

export default Block
